import { Button } from '@mantine/core';
import { useQueryClient } from '@tanstack/react-query';
import { Icon, useAsyncActionWithToast, variants } from '@uag/react-core';
import {
    getGetRequestDetailQueryKey,
    getGetRequestsQueryKey,
    useHideRequest,
} from '@uag/welcome-shared/src/api/queries/requests/requests';
import { useTranslation } from 'react-i18next';

import { openHideRequestModal } from '../modals/HideRequestModal';
import { useRequestContext } from '../RequestProvider';

export const HideRequestAction = () => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const { request } = useRequestContext();
    const { mutateAsync: hideRequest } = useHideRequest();

    const { run } = useAsyncActionWithToast({
        action: hideRequest,
        successMessageKey: 'hideRequestSuccessMessage',
        errorMessageKey: 'hideRequestActionError',
    });

    const handleHide = async () => {
        await openHideRequestModal({
            companyName: request.companyData.companyName ?? undefined,
        });

        await run({ id: request.id });
        queryClient.invalidateQueries({ queryKey: getGetRequestDetailQueryKey(request.id) });
        queryClient.invalidateQueries({ queryKey: getGetRequestsQueryKey() });
    };
    return (
        <Button variant={variants.button.secondary} onClick={handleHide}>
            {t('hide')}
            <Icon className="ml-base" icon="visibility_off" />
        </Button>
    );
};
